import { Box } from "@chakra-ui/react";
import { SYSTEMS } from "./homeContent";
import { Body, CellGrid, DotList, H3, Inner, Intro, Kicker, Section, useHomeTokens } from "./primitives";

/** #systems — "Map it, build it, watch it run". */
export const Systems = () => {
  const t = useHomeTokens();
  return (
    <Section id="systems">
      <Inner>
        <Intro
          kicker="Business process & digital systems"
          title="Map it, build it, watch it run"
          lead="Integrated digital systems, VoIP and intelligent process automation — from the first whiteboard diagram to live dashboards."
          maxW="700px"
        />
        <CellGrid columns={{ base: 1, md: 2, lg: 3 }}>
          {SYSTEMS.map((s) => (
            <Box
              key={s.title}
              p="32px 28px"
              bg={t.bg}
              display="flex"
              flexDirection="column"
              gap="12px"
              minW={0}
              transition="background .2s ease"
              _hover={{ bg: t.bgAlt }}
            >
              <Kicker fontSize="10.5px" letterSpacing=".13em" color={t.primary}>
                {s.kicker}
              </Kicker>
              <H3>{s.title}</H3>
              <Body fontSize=".92rem">{s.body}</Body>
              <DotList items={s.points} mt="8px" />
            </Box>
          ))}
        </CellGrid>
      </Inner>
    </Section>
  );
};
